/**
 * A API devolve campos DataCadastro gravados em UTC, mas sem indicador de fuso
 * (ex.: "2026-10-23T17:16:08"). Sem o "Z", o DatePipe do Angular interpreta o texto no fuso
 * do navegador, e o parâmetro '-0300' do template não converte nada para quem usa o
 * navegador no horário de Brasília: a tela mostra o horário UTC, 3 horas à frente.
 *
 * Esta função marca o texto como UTC quando ele vem sem fuso, para que o template exiba
 * o horário de Brasília (UTC-3) em qualquer navegador. Não altera o valor gravado.
 */
export function paraUtc(data: Date | string): Date {
  if (data instanceof Date) return data;
  const semFuso = !/(z|[+-]\d{2}:?\d{2})$/i.test(data);
  return new Date(semFuso ? `${data}Z` : data);
}
